import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

// Initialize plugins
dayjs.extend(utc)
dayjs.extend(timezone)

const getGameDateTime = (startDate: number) => {
  // Use local timezone on client to avoid off-by-one-day; fallback to UTC on server
  const isClient = typeof window !== "undefined"
  const localTz = isClient ? dayjs.tz.guess() : undefined

  const dateTime = isClient
    ? dayjs(startDate).tz(localTz!)
    : dayjs.utc(startDate)
  const now = isClient ? dayjs().tz(localTz!) : dayjs.utc()

  let date = dateTime.format("DD MMM")
  // We'll return the raw timestamp so it can be formatted by TimeValue component
  const time = startDate

  if (dateTime.isSame(now, "day")) {
    date = "Today"
  } else if (dateTime.isSame(now.add(1, "day"), "day")) {
    date = "Tomorrow"
  }

  return { date, time }
}

export default getGameDateTime
